import React from 'react'

const Cardbtn = ({value,color,text}) => {
  return (
    <>{value && <p className={`${color}  text-white  text-[14px] md:text-[16px] p-[0px_14px] rounded-sm h-fit`}>{text}</p>}</>
  )
}

export default Cardbtn